export default __webpack_public_path__ + "assets/check-component.ba1c7612.svg";